/**
 * StatusRail · Overwatch Auto-System · left column
 * ─────────────────────────────────────────────────
 * Vertical status list mirroring the top-banner tabs — for operators who
 * prefer navigating a rail vs. horizontal tabs (also keeps the pipeline
 * visible while the operator scrolls the middle/right panes).
 */
import React from 'react';
import { Lock, Check, Play, Circle } from 'lucide-react';
import { STATUS_ORDER, useStatusLabels } from '../pipelineApi';

const badge = (state) => {
  if (state === 'complete')    return { Icon: Check,  ring: 'ring-emerald-400', dot: 'bg-emerald-500 text-white' };
  if (state === 'in_progress') return { Icon: Play,   ring: 'ring-sky-400',     dot: 'bg-sky-500 text-white' };
  if (state === 'locked')      return { Icon: Lock,   ring: 'ring-slate-200',   dot: 'bg-slate-100 text-slate-400' };
  return { Icon: Circle, ring: 'ring-slate-200', dot: 'bg-white text-slate-500 border border-slate-300' };
};

export default function StatusRail({ ladder, activeKey, onPick }) {
  const STATUS_LABELS = useStatusLabels();
  return (
    <nav className="w-56 flex-shrink-0 border-r border-slate-200 bg-white overflow-y-auto" data-testid="wf-status-rail">
      <div className="p-3 text-[10px] uppercase tracking-widest text-slate-400 font-semibold">
        Pipeline · One appraisal
      </div>
      <div className="pb-4">
        {STATUS_ORDER.map((key, idx) => {
          const row = ladder.find(r => r.status_key === key) || { state: 'locked' };
          const { Icon, dot } = badge(row.state);
          const active = activeKey === key;
          return (
            <button
              key={key}
              onClick={() => onPick(key, row)}
              data-testid={`wf-rail-${key}`}
              className={`
                w-full flex items-center gap-3 px-3 py-2 text-left border-l-4 transition
                ${active
                  ? 'border-sky-500 bg-sky-50/70'
                  : 'border-transparent hover:bg-slate-50'}
              `}
            >
              <span className={`inline-flex items-center justify-center w-7 h-7 rounded-full ${dot}`}>
                <Icon size={13} strokeWidth={2.5} />
              </span>
              <div className="flex-1 min-w-0">
                <div className="text-[10px] uppercase tracking-widest text-slate-400 leading-none">
                  Step {idx + 1}
                </div>
                <div className={`text-sm font-semibold truncate ${active ? 'text-sky-800' : 'text-slate-800'}`}>
                  {STATUS_LABELS[key]}
                </div>
                {row.state === 'in_progress' && (
                  <div className="text-[10px] text-sky-600 mt-0.5">in progress</div>
                )}
                {row.state === 'complete' && (
                  <div className="text-[10px] text-emerald-600 mt-0.5">complete</div>
                )}
                {row.state === 'locked' && (
                  <div className="text-[10px] text-slate-400 mt-0.5">locked</div>
                )}
              </div>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
